import React, {useEffect, useState, useCallback, useRef} from 'react';
import { Button, TextLink, TextLinkCaret } from '@vds/buttons';
import { InHomeUtils } from './../../util/inhomeUtils';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import { Title, Body, } from '@vds/typography';
import {
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionDetail,
    AccordionTitle,
} from '@vds/accordions';
import styled from 'styled-components';
import { Input } from '@vds/inputs';
import {TitleLockup}  from '@vds/type-lockups';
import {store} from '../../index';
import { ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { FiosReferralKeyboard } from '../fiosRetailTablet/Keyboard/FiosReferralKeyboard';

const Group = styled.div`
  margin-bottom: 16px;
`;

export const InitialSave = (props) => {
    const [isLinkClicked, setIsLinkClicked] = useState(false);
    const [showKeyboard, setShowKeyboard] = useState(false);
    const keyboardRef = useRef(null);

    const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";

    const closeKeyboard = useCallback(() => setShowKeyboard(false));
    const isKeyboardClicked = useCallback(() => setShowKeyboard(true));
    const onKeyboardChange = useCallback(value =>  props.validateIpt && props.validateIpt({target:{ value }}));
    const onKeyPressed = useCallback(button => button === "{accept}" && onSaveLinkClick() );

    useEffect(()=>{
        if(((props?.emailError) && isLinkClicked)){
                    const email = document?.getElementById("emailID")
                    if(email){
                        email.focus();
                    }
        }
    } ,[props?.emailError, isLinkClicked]);
    
    useEffect(() => {
        if(props?.isBackInvoked) {
            document?.getElementById('needHelp').focus()
        }
    }, [props?.isBackInvoked])

    const onSaveLinkClick = () =>{
        setIsLinkClicked(true);
        props.saveClick();
    }

return (
    <div className="ResknModalHeader">
        <ModalTitle>
            {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') &&  <Title size="large" viewport="desktop" primitive="h2" color="black">
                Save your cart.
            </Title>}
            {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <>
                Do you want to save your cart?
            </>}
        </ModalTitle>
        <ModalBody>
            <div className="margin-bottom-medium">
                {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Body size="large" viewport="desktop" primitive="p" color="black">
                    Saving your cart now will save you time later. You'll also get reminders to come back and finish your order.
                </Body>}
                {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <><Body size="large" viewport="desktop" primitive="p" color="black">
                    Save what's in your cart and save time when you return. We'll also email you a reminder.
                </Body></>}
            </div>
            <div className="saveMyCart">
                <Group>
                    <Input
                        id='emailAddress'
                        label={!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? "Email address" : "Email address"}
                        type="text"
                        required={true}
                        onChange={!hostedAttractLoop && props.validateIpt}
                        onClick={isKeyboardClicked}
                        value={props.emailID.replace(/ /g, "").toLowerCase()}
                        error={props.validateInput || props.emailError ? true : false}
                        inputId="emailID"
                        data-cs-mask
                        tabIndex={0}
                        onBlur={()=>{setIsLinkClicked(false)}}
                        autoFocus={false}
                        errorText={props.validateInput ? 'Please enter email address' : props.emailError ? 'Please enter a valid email address' : ''}
                    />
                </Group>
                
            <FiosReferralKeyboard
                keyboardContainerClass={"keyboard-container-for-save-email"}
                onChange={onKeyboardChange}
                onKeyPress={onKeyPressed}
                theme={"plantools"}
                inputName={"emailAddress"}
                closeKeyboard={closeKeyboard}
                showKeyboard={showKeyboard}
                keyboard={keyboardRef}
                planToolsWithSubmit
            />
                <div className="margin-bottom-medium">
                    { !(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Body size="small" color="black">
                        Get email saved cart reminders by providing your contact information above. {' '}
                        <TextLink role="button" onClick={props.onHelpCheck} onKeyPress={props.onHelpCheck} type="standalone" size="small" id="needHelp">Need help?</TextLink>
                    </Body>}
                    {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') &&  <TextLink role="button" id="needHelp" onClick={(e)=>{e.preventDefault(); props.onHelpCheck()}} onKeyPress={props.onHelpCheck} type="standalone" size="small">Need help?</TextLink>}
                </div>
            </div>
            <div className="margin-top-xlarge tiny-12">
                <div className="left medium-6 tiny-12" style={{ paddingBottom: '8px' }}>
                    <Button className={`${(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? 'reskin-savecart' : ''}`} Primary viewport="desktop" width="100%" onClick={onSaveLinkClick} size="large">Save cart</Button>
                </div>
                <div className="left medium-6 tiny-12" >
                    <Button secondary viewport="desktop" className={`${(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? 'reskin-cancel' : ''}`} width="100%" onClick={props.closeModel} size="large">Cancel</Button>
                </div>
            </div>
        </ModalBody>
    </div>
    // <div className="padding-all-zero savecart_modal save-your-cart" style={{ maxHeight: '844.2px', height: 'auto', overflowY: 'auto' }}>
    //     <div className="row margin-vert-zero loop-qualification small-vert-middle">            
    //         <div className="tiny-p-100">
                
    //             <div className="margin-bottom-medium">
    //                 {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') &&  <Title size="large" viewport="desktop" primitive="h2" color="black">
    //                     Save your cart.
    //                 </Title>}
    //                 {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <>
    //                 <Title size="large" viewport="desktop" primitive="h2" color="black">
    //                     Do you want to save your cart?
    //                 </Title></>
    //                 }
    //             </div>
    //             <div className="margin-bottom-medium">
    //                 {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Body size="large" viewport="desktop" primitive="p" color="black">
    //                     Saving your cart now will save you time later. You'll also get reminders to come back and finish your order.
    //                 </Body>}
    //                 {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <><Body size="large" viewport="desktop" primitive="p" color="black">
    //                 Save what's in your cart and save time when you return. We'll also email you a reminder.
    //                 </Body></>}
    //             </div>
    //             <div className="saveMyCart">
    //                 <Group>
    //                     <Input
    //                         label={!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? "Email my cart to me" : "Email address"}
    //                         type="text"
    //                         required={true}
    //                         onChange={props.validateIpt}
    //                         value={props.emailID.replace(/ /g, "").toLowerCase()}
    //                         error={props.validateInput || props.emailError ? true : false}
    //                         inputId="emailID"
    //                         data-cs-mask
    //                         errorText={props.validateInput ? 'Please enter email address' : props.emailError ? 'Please enter a valid email address' : ''}
    //                     />
    //                 </Group>
    //                 <div className="margin-bottom-medium">
    //                     { !(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Body size="small" color="black">
    //                         Get email saved cart reminders by providing your contact information above. {' '}
    //                         <TextLink type="inline" role="button" onClick={props.onHelpCheck} onKeyPress={props.onHelpCheck} type="standalone" size="small">Need help?</TextLink>
    //                     </Body>}
    //                     {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') &&  <TextLink type="inline" role="button"  onClick={props.onHelpCheck} onKeyPress={props.onHelpCheck} type="standalone" size="small">Need help?</TextLink>}
    //                 </div>
    //             </div>
    //             <div className="" style={{ paddingTop: '7px' }}>
    //                <div className="LQ_Button_Bottom stack-vert margin-top-medium tiny-12">
    //                     <div className="left medium-6 tiny-12">
    //                         <Button className={`${(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? 'reskin-savecart' : ''}`} Primary viewport="desktop" width="100%" onClick={props.saveClick} size="large">Save cart</Button>
    //                     </div>
    //                     <div className="left medium-6 tiny-12">
    //                         <Button secondary viewport="desktop" className={`${(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') ? 'reskin-cancel' : ''}`} width="100%" onClick={props.closeModel} size="large">Cancel</Button>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // </div>
    );
}

export const Help = (props) => {
    useEffect(()=>{  
        setTimeout(() => { 
        document?.getElementById("close-button").focus()
        },0);
    } ,[]); 
    
    return (            
            <div className="">
                <div className="row margin-vert-zero padding-bottom-tiny" >
                    <div className="column tiny-12 medium-12 padding-vert-zero margin-top-medium margin-bottom-small">
                        <div className="inline pointer">
                            <TextLinkCaret role="button" onClick={(e) => { e.preventDefault(); props.onHelpCheck(true) }} onKeyPress={(e) => { e.preventDefault(); props.onHelpCheck(true) }} iconPosition="left">Back</TextLinkCaret>
                        </div>
                    </div>
                    <div className="ResknModalHeader">
                        <Title size="medium" viewport="desktop" primitive="h2" color="black" id='needHelp'>
                            Need help?
                    </Title>
                    </div>
                </div>
                <Accordion viewport="desktop" type="single">
                    <AccordionItem>
                        <AccordionHeader>
                            <AccordionTitle primitive="div">Which items are saved in my shopping cart?</AccordionTitle>
                        </AccordionHeader>
                        <AccordionDetail>All selections in your shopping cart will be saved. However, if you save your cart while in the checkout process,
                                        your telephone number selection and Due Date assignment will not be saved.</AccordionDetail>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionHeader>
                            <AccordionTitle primitive="div">How do i complete my order?</AccordionTitle>
                        </AccordionHeader>
                        <AccordionDetail>
                            Finish your order now online, or come back later by clicking on the link in the email
                                                          we will send when you save your order. You can also go to www.verizon.com/savedcart and enter your Saved Cart
                                                          number. Don't have it? No problem. Go to the link above and give us your email address. We'll send you your Saved Cart number.
          </AccordionDetail>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionHeader>
                            <AccordionTitle primitive="div">Will Verizon send me marketing and promotional emails?</AccordionTitle>
                        </AccordionHeader>
                        <AccordionDetail>
                            We will send communications regarding your order and occasional marketing messages, but you will always have the option to unsubscribe.
          </AccordionDetail>
                    </AccordionItem>
                </Accordion>
                <span className="sr-only">Heading level 2 Need help? modal</span>
            </div>        
    );
}

export const SaveInvoked = (props) => {
    let cart = store.getState() && store.getState().cart;
    console.log(cart,'savecart');
    let isSetupFeeWaived=false;
    let isBlackFridayOfferEnabled = false;
    let cyberMondayOfferEnabled = false;
    let isSetupWaiverOffer = InHomeUtils.isNotNull(props.buildProductState) && InHomeUtils.isNotNull(props.buildProductState.internet) && InHomeUtils.isNotNull(props.buildProductState.internet.selectedProduct) 
    && ((InHomeUtils.isNotNull(props.buildProductState.internet.selectedProduct.discountOffers) && props.buildProductState?.internet?.selectedProduct?.discountOffers?.length > 0 
    && props.buildProductState?.internet?.selectedProduct?.discountOffers?.filter(a => a.BsOfferAttrValue && a.BsOfferAttrValue?.indexOf("SETUPFEE") > -1).length > 0) ||
    (InHomeUtils.isNotNull(props.buildProductState.internet.selectedProduct.specialOffers) && props.buildProductState?.internet?.selectedProduct?.specialOffers?.length > 0 
    && props.buildProductState?.internet?.selectedProduct?.specialOffers?.filter(a => a.BsOfferAttrValue && a.BsOfferAttrValue?.indexOf("SETUPFEE") > -1).length > 0)) ? true : false;
    if (InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartData)&& cart.cartData.length>0 && InHomeUtils.isNotNull(cart.cartData[0].oneTimeCharge) && InHomeUtils.isNotNull(cart.cartData[0].oneTimeCharge.onetimecharge)
        && cart?.cartData[0]?.oneTimeCharge?.onetimecharge?.length > 0) {
        let setup = cart?.cartData[0]?.oneTimeCharge?.onetimecharge?.filter(p => p.prodType && p.prodType === "SETUP")
        if (InHomeUtils.isNotNull(setup) && setup.length > 0 && setup[0]?.price !== null) {
            if (setup[0]?.price === "Included") {
                isSetupFeeWaived = true;                    
            }
            else{
                isSetupFeeWaived = false;
            }               
        }
    }

    if (InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartData)&& cart.cartData.length>0 && InHomeUtils.isNotNull(cart.cartData[0].rewardOffers) && InHomeUtils.isNotNull(cart.cartData[0].rewardOffers.rewardOffers)
        && cart?.cartData[0]?.rewardOffers?.rewardOffers?.length > 0) {
        let rewardOffers = cart?.cartData[0]?.rewardOffers?.rewardOffers;
        let isBlackFridayOfferInCart = cart?.cartData[0]?.rewardOffers?.rewardOffers?.filter(p => p.promoId && p.promoId === "R4047" || p.promoId === "R4050" || p.promoId === "R4093");
        console.log(isBlackFridayOfferInCart)

        if(isBlackFridayOfferInCart[0]?.promoId == 'R4047' || isBlackFridayOfferInCart[0]?.promoId == 'R4050' || isBlackFridayOfferInCart[0]?.promoId == 'R4093'){
            isBlackFridayOfferEnabled = true;
           }

        let CyberMondayOfferInCart = cart?.cartData[0]?.rewardOffers?.rewardOffers?.filter(p => p.promoId && p.promoId === "R4139" || p.promoId === "R4141" || p.promoId === "R4142");
        console.log(CyberMondayOfferInCart, 'CyberMondayOfferInCart')

        if(CyberMondayOfferInCart[0]?.promoId == 'R4139' || CyberMondayOfferInCart[0]?.promoId == 'R4141' || CyberMondayOfferInCart[0]?.promoId == 'R4142'){
            cyberMondayOfferEnabled = true;
           }
        
        console.log(cyberMondayOfferEnabled,'cyberMondayOfferEnabled');
       console.log(isBlackFridayOfferEnabled,'isBlackFridayOfferEnabled');
    }

    useEffect(()=>{
        document?.getElementById("close-button").focus()
    } ,[]);

    return (<div className="padding-all-zero savecart_modal">
        <div className="row margin-vert-zero loop-qualification small-vert-middle">            
            <div className="" style={{ userSelect: 'auto' }}>
                
            {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Title size="large" viewport="desktop" primitive="h2" color="black">
                    Your cart has been saved.
                            </Title> }
                    {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <>
                        <TitleLockup
                        data={{
                        eyebrow: {
                        size: 'titleMedium',
                        children: '',
                        },
                        title: {
                        bold: false,
                        size: 'titleLarge',
                        children: 'Your cart has been saved.',
                        primitive: 'h2',
                        },
                        }}
                        /></>}
                <div>
                    <div className="padding-horiz-medium">
                        <Body size="large" viewport="desktop" primitive="p" color="black">
                            Whenever you’re ready, you’ve got two ways to finish your order.
                                </Body>
                    </div>
                    <Body size="large" viewport="desktop" primitive="p" color="black">
                        Click on the link from the email we just sent you or visit verizon.com/savedcart and enter your Saved Cart number. You’ll find everything just where you left it.
                                </Body>
                </div>               
            </div>
            <div className="tiny-p-100 ">                
                <div className="margin-top-medium " style={{ userSelect: 'auto' }}>
                    <p className="Saved-cart-TxtLabel" data-cs-mask > Saved cart sent to :  <span style={{ userSelect: 'text', cursor: 'text' }}> {props.emailID}</span> </p><p className="Saved-cart-TxtLabel" data-cs-mask >Saved Cart number :  <span style={{ userSelect: 'text', cursor: 'text' }}> {props.monno}</span></p>
                    {isBlackFridayOfferEnabled && props?.lqState?.runtimeKey?.isBlackFridayEnabled ? <p className="Saved-cart-TxtLabel holidayoffertext" data-cs-mask >Order by 12/1/2024 midnight EST to receive your Black Friday offer.</p> : cyberMondayOfferEnabled ? <p className="Saved-cart-TxtLabel holidayoffertext" data-cs-mask >Order by 12/2/2024 midnight EST to receive your Cyber Monday offer.</p> : <p className="Saved-cart-TxtLabel" data-cs-mask>Your Pricing will be valid through :  <span> {$.datepicker.formatDate('M dd, yy', new Date(props.saveDate))}</span></p>}
                    
                    {(isSetupFeeWaived || isSetupWaiverOffer) && <div className="padding-horiz-medium">
                        <Body size="large" viewport="desktop" primitive="p" color="black">
                            The standard set up fee waiver is an online exclusive and only valid when completing your order online.
                                </Body>
                    </div>}
                </div>

                <div className="row margin-vert-zero LQ_Button_Bottom stack-vert margin-top-medium tiny-12">
                    <div className="left tiny-margin-right-small p-40">
                        <Button primary width="100%" onClick={props.closeModel} color="black">Ok</Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export const ReSave = (props) => {
    return (
        <div className="padding-all-zero savecart_modal" style={{ maxHeight: '844.2px', height: '436px' }}>
            <div className="row margin-vert-zero loop-qualification small-vert-middle">
                
                <div className="tiny-p-100">
                    <div className="tiny-padding-vert-zero small-padding-vert-small">
                        <div className="margin-bottom-medium">
                            {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Title size="large" viewport="desktop" primitive="h2" color="black">
                                Save your cart.
                                </Title>}
                                {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <>
                                <TitleLockup
                                data={{
                                eyebrow: {
                                size: 'titleMedium',
                                children: '',
                                },
                                title: {
                                bold: false,
                                size: 'titleLarge',
                                children: 'Do you want to save your cart?',
                                },
                                }}
                            /></>}
                        </div>
                    </div>

                    <div className="row tiny-padding-vert-zero small-padding-vert-small margin-vert-zero" style={{ paddingTop: '7px' }}>
                        <div className="row margin-vert-zero medium-vert-middle" data-lq-content="" style={{ height: '166px' }}>
                            <div className="tiny-p-100" style={{ userSelect: 'auto' }}>
                                <p className="margin-bottom-micro bold text-large">Want to save any changes you made?</p>
                                <p className="margin-bottom-micro bold text-large" id="mon_no" data-cs-mask>Your Saved Cart number is: <span style={{ userSelect: 'text', cursor: 'text' }}>{props.monno}</span></p>
                                {<p className="margin-bottom-micro bold text-large">Your Pricing will be valid through : <span>{props.saveDate}</span></p>}
                            </div>
                            <div className="margin-bottom-medium margin-top-small">
                                <TextLink role="button" onClick={props.onHelpCheck} onKeyPress={props.onHelpCheck} id="needHelp" type="standalone" size="small">Need help?</TextLink>
                            </div>
                        </div>
                        <div className="row margin-vert-zero LQ_Button_Bottom stack-vert margin-top-high tiny-12">
                            <div className="left tiny-margin-right-small">
                                <Button Primary viewport="desktop" width="100%" onClick={props.saveClick} size="large">Save cart</Button>
                            </div>
                            <div className="left">
                                <Button secondary viewport="desktop" width="100%" onClick={props.closeModel} size="large">Continue shopping</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
export const ReSaved = (props) => {
    return (<div className="padding-all-zero savecart_modal" style={{ maxHeight: '844.2px', height: '450px' }}>
        <div className="row margin-vert-zero loop-qualification small-vert-middle">
            
            <div className="tiny-p-100 small-p-90 tiny-padding-vert-zero small-padding-vert-small" style={{ userSelect: 'auto' }}>
                
            {!(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <Title size="large" viewport="desktop" primitive="h2" color="black">
                    Your cart has been saved.
                            </Title> }
                {(props.buildProductState.isReskin && props.lqState.runtimeKey.EnableReskin === 'Y') && <>
                <TitleLockup
                data={{
                eyebrow: {
                size: 'titleMedium',
                children: '',
                },
                title: {
                bold: false,
                size: 'titleLarge',
                children: 'Your cart has been saved.',
                },
                }}
                /></>}
                <div className="row margin-vert-zero medium-vert-middle" data-lq-content="" style={{ height: '204px' }}>
                    <div className="column padding-vert-zero">
                        <div className="tiny-p-100 medium-p-90" style={{ userSelect: 'auto' }}>
                            <p className="margin-bottom-micro bold text-large" id="mon_no" data-cs-mask>Here's your Saved Cart number: <span style={{ userSelect: 'text', cursor: 'text' }}>{props.monno}</span></p>
                            {<p className="margin-bottom-micro bold text-large" aria-hidden="false">Your Pricing will be valid through : <span>{props.saveDate}</span></p>}
                        </div>
                    </div>
                </div>
                <div className="row margin-vert-zero LQ_Button_Bottom stack-vert margin-top-medium tiny-12">
                    <div className="left tiny-margin-right-small">
                        <Button primary width="100%" onClick={props.closeModel} color="black">Ok</Button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    );
}